import { useState } from 'react';
import { useHistory } from 'react-router';
import { ArrowBack, PendingActions, SwapCalls } from '@mui/icons-material';
import { Box, Stack, Tooltip } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { URLPaths } from 'models/enums';
import { Campaign } from 'domains/campaigns/types';
import Button from 'domains/core/components/Button';
import Flow from 'domains/core/components/Flow';
import PageHeader from 'domains/core/components/PageHeader';
import ActivitySidesheet from './ActivitySidesheet';

type Props = {
    campaign?: Campaign;
    left: React.ReactNode;
    right?: React.ReactNode;
};

const CampaignDetailsLayout = ({ campaign, left, right }: Props) => {
    const history = useHistory();
    const { auditCuration: hasAuditCurationFeatureFlag } = useFlags();
    const [isActivitySidesheetOpen, setIsActivitySidesheetOpen] = useState(false);
    const handleOpenActivitySidesheet = () => setIsActivitySidesheetOpen(true);
    const handleCloseActivitySidesheet = () => setIsActivitySidesheetOpen(false);

    return (
        <>
            <Flow
                topLeft={<PageHeader icon={<SwapCalls fontSize="inherit" />} header="curation details" />}
                topRight={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {hasAuditCurationFeatureFlag && (
                            <Tooltip title="View Activity" arrow placement="top">
                                <Button
                                    variant="outlined"
                                    sx={{ minWidth: 'auto', padding: 1 }}
                                    onClick={handleOpenActivitySidesheet}
                                >
                                    <PendingActions />
                                </Button>
                            </Tooltip>
                        )}
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBack />}
                            onClick={() => history.push(URLPaths.CURATIONS)}
                        >
                            Back
                        </Button>
                    </Box>
                }
                bottomLeft={<Stack rowGap={4}>{left}</Stack>}
                bottomRight={right}
            />
            <ActivitySidesheet
                campaign={campaign}
                isOpen={isActivitySidesheetOpen}
                onClose={handleCloseActivitySidesheet}
            />
        </>
    );
};

export default CampaignDetailsLayout;
